<template>
    <div
        class="group cursor-pointer menu-container"
        :class="[
            {
                'hover:text-black': inverse,
                'hover:text-primary': !inverse,
                'text-black': !inverse,
                'text-primary': inverse,
                'menu-inverse': inverse,
                'menu-normal': !inverse,
                'is-active': isActive,
            },
        ]"
    >
        <a
            :href="href"
            :class="[
                'flex items-center text-[15px] px-6 py-1 my-2 font-bold ',
                {
                    'text-primary': isActive && !inverse,
                    'text-black': isActive && inverse,
                },
            ]"
            ref="item"
            @click="onClick"
        >
            <template v-if="icon">
                <ion-icon
                    v-if="icon"
                    class="flex-shrink-0 flex-grow-0"
                    :name="icon"
                ></ion-icon>
                <div class="flex-grow flex-shrink-0 mx-4" ref="slotContainer">
                    <slot ref="slot"></slot>
                </div>
                <ion-icon v-if="icon" name="chevron-forward-outline"></ion-icon>
            </template>
            <template v-else>
                <slot ref="slot"></slot>
            </template>
        </a>
        <Teleport to="body" v-show="showSubmenu && $slots.submenu">
            <div
                v-if="showSubmenu"
                class="fixed w-full h-full z-[102] top-0 left-0"
                @click.self="showSubmenu = false"
            ></div>
            <div
                ref="submenu"
                class="bg-white shadow-xl rounded-lg z-[1002] text-black"
                v-show="showSubmenu && $slots.submenu"
            >
                <slot name="submenu"></slot>
            </div>
        </Teleport>
    </div>
</template>

<script>
import { createPopper } from "@popperjs/core";

import { breakpointsTailwind, useBreakpoints } from "@vueuse/core";

export default {
    name: "SidenavItem",
    props: ["isActive", "icon", "isActive", "href", "inverse"],
    watch: {
        showSubmenu() {
            if (this.showSubmenu) {
                const placement = this.breakpoints.greater("md").value
                    ? "right"
                    : "bottom";
                createPopper(this.$refs.item, this.$refs.submenu, {
                    placement,
                }).forceUpdate();
            }
        },
    },
    data() {
        return {
            showSubmenu: false,
        };
    },
    setup() {
        const breakpoints = useBreakpoints(breakpointsTailwind);
        return { breakpoints };
    },
    methods: {
        onClick(e) {
            if (this.$slots.submenu) {
                e.preventDefault();
                this.showSubmenu = !this.showSubmenu;
            }
        },
    },
    mounted() {
        if (window.ReactNativeWebView) {
            document.querySelectorAll(".web-only-button").forEach((element) => {
                element.style.display = "none";
            });
        }
    },
};
</script>

<style scoped>
.menu-container.menu-inverse:hover :slotted(img) {
    filter: brightness(0.2);
}

.menu-container.menu-normal:hover :slotted(img) {
    filter: none;
}

.menu-container.menu-normal:not(.is-active) :slotted(img:not(.img-force)) {
    filter: brightness(0.2);
}

.menu-container.menu-normal:not(.is-active):hover
    :slotted(img:not(.img-force)) {
    filter: none;
}

.menu-container.menu-inverse:hover :slotted(ion-icon) {
    color: black;
}
</style>
